import { render, staticRenderFns } from "./DSperseTechnologyPage.vue?vue&type=template&id=52a39371&scoped=true&"
import script from "./DSperseTechnologyPage.vue?vue&type=script&lang=js&"
export * from "./DSperseTechnologyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a39371",
  null
  
)

export default component.exports